import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'cartasPipe'
})
export class FilterCartaPipe implements PipeTransform {
    transform(cartas: any, term?: any): any {

        if( term === undefined) return cartas;
        if( term === null) return cartas;
        
        if(cartas != null){
            return cartas.filter(function(carta) {
                if (carta.name != undefined) {
                    if (carta.name.toLowerCase().includes(term.toLowerCase())) {
                        return carta;
                    }
                }
                

            })
        }

    }
}


// WEBPACK FOOTER //
// ./src/pages/carta/filter.pipe.ts